import { render, staticRenderFns } from "./NextThreeCourse.vue?vue&type=template&id=96f5fc1e&scoped=true"
import script from "./NextThreeCourse.vue?vue&type=script&lang=js"
export * from "./NextThreeCourse.vue?vue&type=script&lang=js"
import style0 from "./NextThreeCourse.vue?vue&type=style&index=0&id=96f5fc1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f5fc1e",
  null
  
)

export default component.exports